import './droletButton.scss';


import React from 'react';
import arrowIcon from '../../../src/images/icons/Icon-Fleche.svg';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LocalizedLink from './LocalizedLink';
import { IButton } from '../../interfaces/interfaces';

function Label(props: any) {
    const text = props.children || props.label;

    return props.isLoading ? (
        <FontAwesomeIcon className='spinner' icon={faSpinnerThird} spin />
    ) : (
        <>
            {props.icon && <img src={props.icon} alt={props.icon} />}
            {text && <span>{text}</span>}
            <img className='iconRight' src={arrowIcon} alt='' />
        </>
    );
}

export default function DroletButton(props: IButton) {
    if (props.link) {
        return (
            <LocalizedLink
                to={props.link}
                className={`drolet-button ${props.className}`}
                state={props.state}
            >
                <Label {...props} />
            </LocalizedLink>
        );
    } else {
        return (
            <button
                disabled={props.disabled || props.isLoading}
                onClick={(e) => props.onClick && props.onClick(e)}
                onMouseEnter={(e) =>
                    props.onMouseEnter && props.onMouseEnter(e)
                }
                onMouseLeave={(e) =>
                    props.onMouseLeave && props.onMouseLeave(e)
                }
                className={`drolet-button ${props.className}`}
                form={props.form}
                type={props.type ? props.type : 'submit'}
            >
                <Label {...props} />
            </button>
        );
    }
}
